import * as React from 'react';
import {
	Field as UnityField,
	Typeahead
} from 'react-unity';
import { useState, useRef, useEffect } from 'react';
import { Validation } from '../../../utils/Validation';
import SubscriptionRequestsService from '../../../services/SubscriptionRequestsService';
import SubscriptionRequest from '../../../models/entities/SubscriptionRequest';
import { FieldProps } from './Field';
import ReadonlyField from './ReadonlyField';

interface SubscriptionLookupProps extends FieldProps {
	label?: string;
	id?: number;
	disabled?: boolean;
	onChange: (sub: SubscriptionRequest) => any
	setVNetsToSpoke?: any;
	resetPOR?: any;
}


const SubscriptionLookup = (props: SubscriptionLookupProps) => {

	const subsService = new SubscriptionRequestsService();
	const [searching, setSearching] = useState<boolean>(false);
	const [subsSearchResults, setSubsSearchResults] = useState<SubscriptionRequest[]>([]);
	const [retrievedResults, setRetrievedResults] = useState<boolean>(false);
	const [clearRuleSet, setClearRuleSet] = useState<boolean>(false);
	const searchText = useRef<string>('');
	const typeSelected = useRef<string>('');


	const getInitialState = (newValue) => {
		searchText.current = newValue ?? '';
		setSearching(false);
		setSubsSearchResults([]);
		setRetrievedResults(false);
		typeSelected.current = newValue ?? '';
	};

	const searchApplicationInfo = async () => {
		setSubsSearchResults([]);
		const searchString = searchText.current;
		if (searchString?.length <= 2)
			return;
		setSearching(true);
		try {
			const subsInfo = (await subsService.subscriptionsLookup(searchString))
				.filter(sub => sub.id !== props?.id);
			setSubsSearchResults(subsInfo);
		} catch (error) {
			const HTTP_NOT_FOUND_ERROR_CODE = 404;
			if (error.status !== HTTP_NOT_FOUND_ERROR_CODE) {
				console.log('An unexpected error occurred while retrieving data from Subscription Repository.');

			}
		}
		setSearching(false);
		setRetrievedResults(true);
	};

	const isValid = (): boolean => {
		if (!props.validation) return true;
		return new Validation(props.validation).assert(props.value);
	}

	const handleTextChange = async (e) => {
		searchText.current = e.target.value;
		setSubsSearchResults([]);
		setRetrievedResults(false);
		searchApplicationInfo();
	};

	useEffect(() => {
		if(props.value !== undefined){
			resetInputText(props.value?.createdSubscriptionName);
			setClearRuleSet(true);
		}
	}, [props.value]);
	
	const resetInputText = (value) => {
		getInitialState(value);
	};

	return (
		<>
			{!props.disabled ?
				<UnityField>
					<UnityField.Label>
						{props.label}
					</UnityField.Label>
					<Typeahead
						className="em-u-width-100"
						onChange={async (e, value) => {
							const obj = subsSearchResults.find(o => o.id === value);
							resetInputText('');
							searchText.current = obj?.createdSubscriptionName;
							if(clearRuleSet) props.resetPOR();
							setRetrievedResults(true);
							const subnets =  await subsService.getAddressSpaces(obj.id);
							props.setVNetsToSpoke(subnets, obj.id);
							props.onChange(obj);
							setSubsSearchResults([]);
						}}
						fieldProps={{
							label: '',
							error: !isValid(),
							note: '',
						}}
						inputProps={{
							onChange: (e) => handleTextChange(e),
							placeholder: "Subscription's Name",
							value: searchText.current,
							loading: searching,
						}}
					>
						{retrievedResults && !subsSearchResults?.length ? (
							<Typeahead.Item value={0} onClick={() => { }}>
								<Typeahead.Item.Suggestion aria-disabled={true}>
									<i>Object was not found</i>
								</Typeahead.Item.Suggestion>
							</Typeahead.Item>
						) : (
							subsSearchResults?.map((sub) => (
								<Typeahead.Item value={sub?.id} key={sub?.id}>
									<Typeahead.Item.Suggestion>
										<span>{sub?.createdSubscriptionName}</span>
									</Typeahead.Item.Suggestion>
								</Typeahead.Item>
							))
						)}
					</Typeahead>
				</UnityField>
				:
				<ReadonlyField
					label={props.label}
					text={props.value?.createdSubscriptionName}
				/>
			}
		</>
	);
}

export default SubscriptionLookup;